import React, { Component } from 'react';
import moment from 'moment';

const Session = (props) => {
  let date = props.session? moment(props.session.date_created, "MM/DD/YYYY hh:mm").format('L') : '';
  let time = props.session? moment(props.session.date_created, "MM/DD/YYYY hh:mm").format('hh:mm a') : '';
    return(
      <tr>
        <td>{props.session.id}</td>
        <td className="hidden-xxs-down">{date + ' ' + time}</td>
        <td className="hidden-xs-down"><span className="badge badge-pill badge-warning">{props.session.station.name}</span></td>
        {/*<td>{props.session.main_product.name}</td>*/}
        <td className="hidden-xs-down">{props.session.user}</td>
        <td className="hidden-xs-down">
          {props.session.is_finished?
            <span className="badge badge-pill badge-info">Finished</span>
            :
            <span className="badge badge-pill badge-danger">In Progress</span>
          }
        </td>
        <td>
          <span className="btn-sm btn-info" onClick={() => props.editSession(props.session.id,props.session.is_finished)}>
            {props.session.is_finished?
              <i className="fa fa-eye"></i>
              :
              <i className="fa fa-edit"></i>
            }
          </span>
        </td>
      </tr>
    )
}

export default class SessionsList extends Component {
  render() {
    return (
      <tbody>
        {this.props.sessions.sessions.map((session,index)=>{
          return(
            <Session session={session} editSession={this.props.editSession} key={index}/>
          )
        })}
      </tbody>
    )
  }
}
